<template>
  <modal class="modal" :show="modal_show" body-classes="card-body" modal-classes="modal-dialog-centered modal-sm"
    footer-classes="card-footer" header-classes="card-header" v-on:close="onClose()">

    <template v-slot:header>
      <h2>{{ $t(this.$route.name + '.generatingReport') }}</h2>
    </template>
    <div id="card-body">
      <div class="row progress">
        <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar"
          :aria-valuenow="progressValueGenRep" aria-valuemin="0" aria-valuemax="100" :style="'width: '+progressValueGenRep+'%'"></div>
      </div>
      <div class="row">
        <small>{{ progressGenRepMessage }}</small>
      </div>
    </div>

  </modal>
  <div id="graphics-manager" class="card">
    <div class="card-header border-0">
      <div class="row align-items-center">
        <div class="col-auto">
          <h3 class="mb-0">{{ $t($route.name + '.graphicsManagerTitle') }}</h3>
        </div>
      </div>
      <br>
      <div class="row justify-items-center" v-if="noModuleAvailable">
        <div class="col">{{ $t($route.name + '.noModulesAvailable') }}</div>

      </div>
      <!-- End of no modules available -->

      <!-- Chart toolbar menu -->
      <div v-else>
        <div class="row align-items-center">
          <!-- Module selector -->
          <div class="col-auto">
            <select v-on:change="onSelectModule">
              <option disabled selected>{{ $t($route.name + '.selectorPlaceholder') }}</option>
              <option v-for="module in moduleList" :key="module" v-bind:value="module.model.id">
                {{ module.model.name }}
              </option>
            </select>
          </div>
          <!-- End of Module selector -->

          <!-- Date picker -->
          <div class="col-auto">
            <v-date-picker class="inline-block" v-model="date" is-range :min-date="minDate" :max-date="maxDate"
              :locale="getUserLanguage()" :disabled-dates="moduleSelected == null" v-on:dayclick="handleDataPickerInput">
              <template v-slot="{ inputValue, togglePopover }">
                <div class="flex items-center">
                  <a type="button" style="padding: 10px;" @click="togglePopover()">
                    <i class="ni ni-calendar-grid-58"></i>
                  </a>
                  <input :value="inputValue.start"
                    class="bg-white text-gray-700 w-full py-1 px-2 appearance-none border rounded-r focus:outline-none focus:border-blue-500"
                    v-on:focus="togglePopover()" readonly />
                  <i class="ni ni-curved-next" style="padding: 10px;"></i>
                  <input :value="inputValue.end"
                    class="bg-white text-gray-700 w-full py-1 px-2 appearance-none border rounded-r focus:outline-none focus:border-blue-500"
                    v-on:focus="togglePopover()" readonly />
                </div>
              </template>
            </v-date-picker>
          </div>
          <!-- End of Date picker -->
          <div class="col vr"></div>

          <!-- Generator button -->
          <div class="col-auto align-self-end">

            <div class="dropdown" v-if="charDataReady && (fetchDataStatus == 'Fetch Success')">
              <button class="btn btn-secondary dropdown-toggle" type="button" data-toggle="dropdown"
                aria-expanded="false">
                {{ $t($route.name + '.generateReport') }}
              </button>
              <ul class="dropdown-menu" v-on:click="(e) => { e.stopPropagation(); }">
                <li v-if="chartsData.temperatureAndHumidity.enabled">
                  <a class="dropdown-item"
                    v-on:click="dropdownOptions.temperatureAndHumidity = !dropdownOptions.temperatureAndHumidity">
                    <div class="form-check">
                      <input class="form-check-input" type="checkbox"
                        v-on:change="dropdownOptions.temperatureAndHumidity = !dropdownOptions.temperatureAndHumidity"
                        :checked="dropdownOptions.temperatureAndHumidity" />
                      <label class="form-check-label" for="Checkme1">{{ $t($route.name + '.temperatureDropdownItem')
                      }}</label>
                    </div>
                  </a>
                </li>

                <li v-if="chartsData.leafHumidity.enabled">
                  <a class="dropdown-item" v-on:click="dropdownOptions.leafHumidity = !dropdownOptions.leafHumidity">
                    <div class="form-check">
                      <input class="form-check-input" type="checkbox"
                        v-on:change="dropdownOptions.leafHumidity = !dropdownOptions.leafHumidity"
                        :checked="dropdownOptions.leafHumidity" />
                      <label class="form-check-label" for="Checkme1">{{ $t($route.name + '.leafHumidityDropdownItem')
                      }}</label>
                    </div>
                  </a>
                </li>

                <li v-if="chartsData.soilMoisture.enabled">
                  <a class="dropdown-item" v-on:click="dropdownOptions.soilMoisture = !dropdownOptions.soilMoisture">
                    <div class="form-check">
                      <input class="form-check-input" type="checkbox"
                        v-on:change="dropdownOptions.soilMoisture = !dropdownOptions.soilMoisture"
                        :checked="dropdownOptions.soilMoisture" />
                      <label class="form-check-label" for="Checkme1">{{ $t($route.name + '.soilMoistureDropdownItem')
                      }}</label>
                    </div>
                  </a>
                </li>

                <li v-if="chartsData.rainAndFlow.enabled">
                  <a class="dropdown-item" v-on:click="dropdownOptions.rainAndFlow = !dropdownOptions.rainAndFlow">
                    <div class="form-check">
                      <input class="form-check-input" type="checkbox"
                        v-on:change="dropdownOptions.rainAndFlow = !dropdownOptions.rainAndFlow"
                        :checked="dropdownOptions.rainAndFlow" />
                      <label class="form-check-label" for="Checkme1">{{ $t($route.name + '.rainAndFlowDropdownItem')
                      }}</label>
                    </div>
                  </a>
                </li>
                
                <li>
                  <hr class="dropdown-divider" />
                </li>
                <li>
                  <a class="dropdown-item">
                    <button class="btn btn-primary" v-on:click="generateReport" :disabled="checkAnyChartSelected()">{{
                      $t($route.name + '.download')
                    }}</button>
                  </a>
                </li>

              </ul>
            </div>


            <button
              v-if="(fetchDataStatus == 'Not Fetching') || (fetchDataStatus == 'Not Found') || (fetchDataStatus == 'Fetch Success')"
              class="btn btn-icon btn-primary" v-on:click="generateCharts()"
              :disabled="(moduleSelected == null) || (date.start == null) || (date.end == null)">{{ $t($route.name +
                '.generateChartsButton') }}</button>
            <button v-else class="btn btn-icon btn-primary" disabled>
              <div class="row">
                <div class="col-sm-1">
                  <div class="spinner-border spinner-border-sm text-light" role="status"></div>
                </div>
                <div class="col">{{ $t($route.name +
                  '.fetchingDataButton') }}...</div>
              </div>
            </button>
          </div>
          <!-- End of Generator button -->
        </div>
      </div>
      <!-- End of chart toolbar menu -->
    </div>


    <!-- End of Card header -->
    <div class="card-body" v-if="charDataReady && (fetchDataStatus == 'Fetch Success')">



      <TemperatureHumidityChart ref="temperatureHumidityChart" v-if="chartsData.temperatureAndHumidity.enabled"
        :split-dataset="chartsData.temperatureAndHumidity.dataset" />

      <br>
      <LeafHumidityChart ref="leafHumidityChart" v-if="chartsData.leafHumidity.enabled"
        :split-dataset="chartsData.leafHumidity.dataset" />


      <br>
      <SoilProbesChart ref="soilProbesChart" v-if="chartsData.soilMoisture.enabled && processedDataReady"
        :split-dataset="chartsData.soilMoisture.dataset" :analysis-data="chartsData.soilMoisture.analysis" />
      <br>
      <RainAndFlowChart ref="rainFlowChart" v-if="chartsData.rainAndFlow.enabled"
        :split-dataset="chartsData.rainAndFlow.dataset" />

      <br>
      <BatteryVoltageChart ref="battery-chart" v-if="chartsData.battery.enabled"
        :split-dataset="chartsData.battery.dataset" />

    </div>
    <div v-else-if="fetchDataStatus == 'Not Found'" class="card-body">
      <div class="row justify-content-center">
        <p style="padding-right: 40px;">
          {{ $t(this.$route.name + '.fetchingNotFoundMessage') }}
        </p>
      </div>
    </div>
    <div v-if="(fetchDataStatus == 'Fetching') && !charDataReady" class="card-body">
      <div class="row justify-content-center">
        <p style="padding-right: 40px;">
          {{ $t(this.$route.name + '.fetchingDataMessage') }}...<br>
          <small>{{ $t(this.$route.name + '.largeDataAdviseMessage') }}</small>
        </p>
      </div>
    </div>
    <!-- End of Card Body -->
  </div>
  <!-- REPORT HEADER -->
  <div id="report-header" hidden>
    <div id="logo" class="row justify-content-between data-header">
      <div class="col">
        <div class="row">
          <div class="col-3 header-title"><b>{{ $t(this.$route.name + '.moduleName') }}:</b></div>
          <div class="col-6 header-data" v-if="moduleSelected != null">{{ moduleSelected.name }}</div>
        </div>
        <div class="row">
          <div class="col-3 header-title"><b>{{ $t(this.$route.name + '.moduleId') }}:</b></div>
          <div class="col-6 header-data" v-if="moduleSelected != null">{{ moduleSelected.id }}</div>
        </div>
        <div class="row">
          <div class="col-3 header-title"><b>{{ $t(this.$route.name + '.modulePeriod') }}:</b></div>
          <div class="col-6 header-data" v-if="date != null">{{ showDate(date.start) }} - {{ showDate(date.end) }}</div>
        </div>

      </div>
      <div class="col-4 logo-div">
        <img src="static/img/brand/name_only.png" class="logo-custom" alt="...">
        <div class="copyright text-center text-lg-right text-muted">
          © {{ year }}
          <a href="https://www.agroupadvisor.com" class="font-weight-bold ml-1" target="_blank">AgroUPadvisor</a>
        </div>

      </div>
    </div>

  </div>
</template>

<script>
import BatteryVoltageChart from "./BatteryVoltageChart.vue"
import TemperatureHumidityChart from "./TemperatureHumidityChart.vue"
import SoilProbesChart from "./SoilProbesChart.vue"
import RainAndFlowChart from "./RainAndFlow.vue"
import LeafHumidityChart from "./LeafHumidityChart.vue"

import LandlordService from "@/services/landlord.service"
import DataService from "@/services/data.service"
import ModuleService from "@/services/module.service"
import ProcessedDataService from "@/services/processedData.service"

import { parseListOfProcessedDataSplit } from "@/parsers/data.parser"

import html2pdf from "html2pdf.js"

export default {
  name: "GraphicsManager",
  components: {
    BatteryVoltageChart,
    TemperatureHumidityChart,
    SoilProbesChart,
    RainAndFlowChart,
    LeafHumidityChart
  },
  data() {
    return {
      date: {
        start: null,
        end: null
      },
      year: new Date().getFullYear(),
      minDate: null,
      maxDate: null,
      selectingRange: false,
      absMinDate: null,
      absMaxDate: null,
      dataReady: false,
      moduleList: [],
      noModuleAvailable: true,
      moduleSelected: null,
      charDataReady: false,
      processedDataReady: false,
      fetchDataStatus: 'Not Fetching',
      modal_show: false,
      progressValueGenRep: 0,
      progressGenRepMessage: "",
      chartsData: {
        battery: {
          dataset: [],
          enabled: true
        },
        temperatureAndHumidity: {
          dataset: [],
          enabled: false
        },
        soilMoisture: {
          dataset: [],
          enabled: false,
          analysis: {
            cc: null,
            pmp: null,
            pr: null,
            crad: null
          }
        },
        rainAndFlow: {
          dataset: [],
          enabled: false
        },
        leafHumidity: {
          dataset: [],
          enabled: false
        }
      },
      dropdownOptions: null
    }
  },
  mounted() {

    const user = JSON.parse(localStorage.getItem("user")).user;

    this.maxDate = new Date().toISOString().slice(0, 10)
    this.absMaxDate = this.maxDate;

    LandlordService.getLandlordAllModules(user.id).then(
      data => {
        this.moduleList = data.module_list;
        if (this.moduleList.length == 0) {
          this.noModuleAvailable = true;
        } else {
          this.noModuleAvailable = false;
        }

        this.dataReady = true

      }
    );


  },
  methods: {
    getUserLanguage() {
      return this.$i18n.locale;
    },
    getYesterday(dateISOString = false) {
      let d = new Date();
      d.setDate(d.getDate() - 30);
      return dateISOString ? new Date(d).toISOString() : d;
    },
    generateCharts() {
      this.charDataReady = false;
      this.fetchDataStatus = 'Fetching';
      DataService.getDataByModuleIdAndDateRange(
        this.moduleSelected.id,
        this.formatDate(this.date.start),
        this.formatDate(this.date.end),
      ).then(data => {
        const reversedData = data.reverse()
        const soilMeterProbes = []
        if (this.moduleSelected.sensors.soil_probe_15cm) {
          soilMeterProbes.push("soil_1_meter")
        }
        if (this.moduleSelected.sensors.soil_probe_30cm) {
          soilMeterProbes.push("soil_2_meter")
        }
        if (this.moduleSelected.sensors.soil_probe_45cm) {
          soilMeterProbes.push("soil_3_meter")
        }

        this.chartsData.battery.dataset = parseListOfProcessedDataSplit(reversedData, ["battery_voltage"], this)
        this.chartsData.temperatureAndHumidity.dataset = parseListOfProcessedDataSplit(reversedData, ["temp_meter", "hum_meter"], this)
        this.chartsData.soilMoisture.dataset = parseListOfProcessedDataSplit(reversedData, soilMeterProbes, this)
        this.chartsData.leafHumidity.dataset = parseListOfProcessedDataSplit(reversedData, ["leaf_meter"], this)
        this.chartsData.rainAndFlow.dataset = parseListOfProcessedDataSplit(reversedData, ["rain_meter", "gauge_meter"], this)

        this.charDataReady = true;
        this.fetchDataStatus = 'Fetch Success';
      },
        error => {
          if (error.response.status == 404) {
            this.fetchDataStatus = "Not Found"
          } else {
            console.log(error)
          }
        }
      )

      if (this.chartsData.soilMoisture.enabled) {
        ProcessedDataService.getSoilMoistureProcessedAnalysis(
          this.moduleSelected.id,
          this.formatDate(this.date.start),
          this.formatDate(this.date.end),
        ).then((data) => {
            if(data.cc != 0){
              this.chartsData.soilMoisture.analysis.cc = data.cc;
            }
            if(data.pmp != 0){
              this.chartsData.soilMoisture.analysis.pmp = data.pmp;
            }
            if(data.crad != 0){
              this.chartsData.soilMoisture.analysis.crad = data.crad;
            }
            if(data.pr != 0){
              this.chartsData.soilMoisture.analysis.pr = data.pr;
            }
            this.chartsData.soilMoisture.analysis.type = data.type;
            this.processedDataReady = true;
        })
      }
    },
    formatDate(date) {
      if (typeof date == "string") {
        if (/^\d+$/.test(date)) {
          return date;
        }
        return date.replace(/-/g, "");
      }
      const year = date.getFullYear();
      const month = ('0' + (date.getMonth() + 1)).slice(-2);
      const day = ('0' + date.getDate()).slice(-2);
      return (`${year}${month}${day}`);
    },
    onSelectModule(event) {
      const moduleId = event.target.value
      ModuleService.getModuleById(moduleId).then(module => {
        this.moduleSelected = module;
        this.minDate = new Date(module.installation_date).toISOString().slice(0, 10);
        this.absMinDate = this.minDate;

        this.dropdownOptions = {}

        this.chartsData.temperatureAndHumidity.enabled = (module.sensors.temperature && module.sensors.relative_humidity);
        this.dropdownOptions.temperatureAndHumidity = (module.sensors.temperature && module.sensors.relative_humidity);

        this.chartsData.soilMoisture.enabled = module.sensors.soil_probe_15cm
        this.dropdownOptions.soilMoisture = module.sensors.soil_probe_15cm

        this.chartsData.leafHumidity.enabled = module.sensors.leaf_humidity
        this.dropdownOptions.leafHumidity = module.sensors.leaf_humidity

        this.chartsData.rainAndFlow.enabled = (module.sensors.rainmeter && module.sensors.flowmeter)
        this.dropdownOptions.rainAndFlow = (module.sensors.rainmeter && module.sensors.flowmeter)

        this.charDataReady = false

      })
    },
    showDate(date) {
      if (date == null) {
        return null
      }
      return date.toISOString().slice(0, 10).replaceAll('-', '/');
    },
    handleDataPickerInput(event) {
      const absMaxDate = new Date(this.absMaxDate)
      const absMinDate = new Date(this.absMinDate)
      var minDate = new Date(event.id)
      var maxDate = new Date(event.id)
      if (!this.selectingRange) {
        minDate.setMonth(minDate.getMonth() - 1)
        maxDate.setMonth(maxDate.getMonth() + 1)
        if (maxDate > absMaxDate) {
          maxDate = absMaxDate;
        }
        if (minDate < absMinDate) {
          minDate = absMaxDate;
        }
        this.selectingRange = true;
      } else {
        maxDate = absMaxDate;
        minDate = absMinDate;
        this.selectingRange = false;
      }
      this.maxDate = maxDate.toISOString().slice(0, 10)
      this.minDate = minDate.toISOString().slice(0, 10)

    },
    async generateReport() {
      this.setReportLoadingModal()

      // Choose the element and save the PDF for our user.
      const headerNode = document.getElementById("report-header")
      const header = headerNode.cloneNode(true)
      header.removeAttribute("hidden")

      const div = document.createElement('div')
      const page1 = document.createElement('div')
      page1.classList = "page"
      page1.appendChild(header.cloneNode(true))

      const page2 = document.createElement('div')
      page2.classList = "page"
      page2.appendChild(header.cloneNode(true))

      let graphicsCounter = 0;
      let page = page1

      const numDropdownOptions = Object.keys(this.dropdownOptions).length + 1
      const enabledDropdownOptions = Object.values(this.dropdownOptions).reduce((a, item) => a + item, 0) + 1

      const progressBarStep = enabledDropdownOptions * 100 / numDropdownOptions;


      if (this.dropdownOptions.temperatureAndHumidity) {
        this.progressGenRepMessage = this.$t(this.$route.name + '.genTempHumChartMsg')
        const tempHumChartDiv = await this.$refs.temperatureHumidityChart.getChartElement('1076px', '250px')
        tempHumChartDiv.style.paddingTop = '10px'
        page.appendChild(tempHumChartDiv)

        if (++graphicsCounter > 1) {
          page = page2;
        }
        this.progressValueGenRep += progressBarStep;
      }
      if (this.dropdownOptions.leafHumidity) {
        this.progressGenRepMessage = this.$t(this.$route.name + '.genLeafHumChartMsg')
        const leafChartDiv = await this.$refs.leafHumidityChart.getChartElement('1076px', '250px')
        page.appendChild(leafChartDiv)

        if (++graphicsCounter > 1) {
          page = page2;
        }
        this.progressValueGenRep += progressBarStep;
      }

      if (this.dropdownOptions.soilMoisture) {
        this.progressGenRepMessage = this.$t(this.$route.name + '.genSoilChartMsg')
        const soilChartDiv = await this.$refs.soilProbesChart.getChartElement('1076px', '250px')
        soilChartDiv.style.paddingTop = '10px'

        page.appendChild(soilChartDiv)

        if (++graphicsCounter > 1) {
          page = page2;
        }
        this.progressValueGenRep += progressBarStep;
      }

      if (this.dropdownOptions.rainAndFlow) {
        this.progressGenRepMessage = this.$t(this.$route.name + '.genRainFlowChartMsg')
        const rainFlowChartDiv = await this.$refs.rainFlowChart.getChartElement('1076px', '250px')
        page.appendChild(rainFlowChartDiv)

        if (++graphicsCounter > 1) {
          page = page2;
        }
        this.progressValueGenRep += progressBarStep;
      }


      div.appendChild(page1)
      if (graphicsCounter > 2) {
        div.appendChild(page2)
      }

      const filename = this.moduleSelected.name + '_' + this.formatDate(this.date.start) + '_' + this.formatDate(this.date.end);
      var opt = {
        margin: 10,
        filename: filename,
        image: { type: 'jpeg', quality: 1 },
        html2canvas: { scale: 4, dpi: 192 },
        jsPDF: { unit: 'mm', format: 'a4', orientation: 'landscape' },
        pagebreak: { mode: ['avoid-all', 'css'] }
      };


      this.progressGenRepMessage = this.$t(this.$route.name + '.genPDFMsg')
      html2pdf()
        .set(opt)
        .from(div)
        .toPdf().get('pdf').then(function (pdf) {
          const totalPages = pdf.internal.getNumberOfPages();

          for (let i = 1; i <= totalPages; i++) {
            pdf.setPage(i);
            pdf.setFontSize(10);
            pdf.setTextColor(150);
            pdf.text(pdf.internal.pageSize.width - 20, pdf.internal.pageSize.height - 10, i + ' / ' + totalPages);
          }
        }).save();
        this.progressValueGenRep += progressBarStep;
        this.progressGenRepMessage = this.$t(this.$route.name + '.genDownloadingPDFMsg')
        this.onClose()

    },

    checkAnyChartSelected() {
      let result = false;
      for (const property in this.dropdownOptions) {
        result |= this.dropdownOptions[property]
      }
      return !result
    },

    onClose() {
      this.modal_show = false;
    },

    setReportLoadingModal() {
      this.modal_show = true;
      this.progressValueGenRep = 0;
      this.progressGenRepMessage = ""
    }

  },
};
</script>

<style>
.page {
  min-height: 715px;
  page-break-after: always;
}

.logo-custom {
  height: 65px;
}

.data-header {
  max-height: 100px;
  padding-top: 10px;
  border-bottom: 2px solid black;
}

.logo-div {
  text-align: end;
}
</style>
